export const FETCH_ALL_IMAGES = "FETCH_ALL_IMAGES";
export const FETCH_PENDING_IMAGES = "FETCH_PENDING_IMAGES";
export const FETCH_IMAGE = "FETCH_IMAGE";
export const UPLOAD_IMAGE = "UPLOAD_IMAGE";
export const UPDATE_IMAGE = "UPDATE_IMAGE";
export const DELETE_IMAGE = "DELETE_IMAGE";
